const {hashPageId} = currentEnvironment;

// sticky position of the icon
const $socialMediaItemsElement = $('.socialMediaItems');
const $favouriteItemsElement = $('.favouriteItems');
// if the page has social media elements
if ($socialMediaItemsElement.length) {
    const top = parseInt($socialMediaItemsElement.css('top'), 10);
    $favouriteItemsElement.css('top', top + 162)
}

// favourite icon click
$('.favouriteIcon').on('click', function () {
    const $favouriteIcon = $(this);
    let requestType = 'GET';
    if ($favouriteIcon.hasClass('favourite')) {
        $favouriteIcon.removeClass('favourite');
        requestType = 'DELETE';
    } else {
        $favouriteIcon.addClass('favourite');
    }
    $.ajax({
        url: `/user/favourites/${hashPageId}`,
        type: requestType,
        dataType: 'json',
        success: function (response) {
            const favModal = $('#modalFavourite');
            $('#favourite-response').html(response.msg);
            favModal.modal('show');
            setTimeout(function () {
                favModal.modal('hide');
            }, 2000);
        }
    });

    return false;
});
